import TabNavItem from "../components/TabNavItem";
import TabContent from "../components/TabContent";
import { Link } from "react-router-dom";
import "../components/Tabs.css";
import React, { useState } from "react";
import GIF1500 from "./img/gif1500.png";
import EVISX1 from "./img/evisx1.png";
import CV1500 from "./img/CV-1500.png";
import CF1500 from "./img/cf1500.png";
import CFH290 from "./img/CF-H290LI.png";
import GIFH290 from "./img/GIF-H290.png";
import OERAW from "./img/올림푸스.png";


import SubHeader from "../components/subHeader2";
import i18next from "../config/lang/i18next";

const options = ["OER-AW", "b", "c"];

const Software = () => {
  const [activeTab, setActiveTab] = useState("OER-AW");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("OER-AW");

  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
    console.log(selectedOption);
  };
  return (
    <div className="wrapper">
      <style>
        {`
      .Tabs2 ul.nav {
        width: 40%;
        min-width:unset;
      }
      .Tabs2 ul.nav li {
        width: 47%;
      }
      .pDesc .btns {
        width: 100%;
        display:flex;
        justify-content:center;
      }
      `}
      </style>
      <SubHeader />

      <div className="prod">
        <div className="">
          <div className="section_title">
            <h1 className="headerText">Medical Device</h1>
          </div>

         
            
            <div className="device_wrap">

                <div style={{display:"flex"}}>
                  {/*}
                <Link className="pd_row banner_img" to="/device/d1">
                  <img
                    src={OEV321UH}
                    alt="ex1"
                  ></img>
                  <div class="hover_text">
                    <h3>OEV-321UH</h3>
                    <p>올림푸스 내시경 시스템에 최적화된 32인치 LCD 모니터</p>
                    <button>자세히 보기</button>
                  </div>
                </Link>
                  */}

<Link className="pd_row banner_img" style={{display:"flex", alignItems:"center"}} to="/device/d1">
                  <img
                    src={EVISX1}
                    alt="ex1"
                    style={{ height:"auto" }}
                  ></img>

                  <div class="hover_text">
                    <h3>EVIS X1</h3>
                    <p>{i18next.t("d1")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>
                <Link className="pd_row banner_img" to="/device/d2">
                  <img
                    src={CV1500}
                    alt="ex1"
                  ></img>
                  <div class="hover_text">
                    <h3>CV-1500</h3>
                    <p>
                    {i18next.t("d2")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>
                </Link>
                
                <Link className="pd_row banner_img" to="/device/d3">
                  <img
                    src={GIF1500}
                    alt="ex1"
                    style={{height:"100%"}}
                  ></img>

                  <div class="hover_text">
                    <h3>GIF-EZ1500</h3>
                    <p>{i18next.t("d3")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>

                <Link className="pd_row banner_img" to="/device/d4">
                  <img
                    src={CF1500}
                    alt="ex1"
                    style={{height:"100%"}}
                  ></img>

                  <div class="hover_text">
                    <h3>CF-EZ1500DL/I</h3>
                    <p>{i18next.t("d4")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>

                </div>
              
                <div className="pd_row_wrap" style={{display:"flex"}}>


                <Link className="pd_row banner_img" style={{display:"flex", alignItems:"center"}} to="/device/d5">
                  <img
                    src={GIFH290}
                    alt="ex1"
                  ></img>

                  <div class="hover_text">
                    <h3>GIF-H290</h3>
                    <p>{i18next.t("d5")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>
                <Link className="pd_row banner_img" to="/device/d6">
                  <img
                    src={CFH290}
                    alt="ex1"
                  ></img>

                  
                  <div class="hover_text">
                    <h3>CF-H290L/I</h3>
                    <p>{i18next.t("d6")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>

                <Link className="pd_row banner_img" to="/device/d7">
                  <img
                    src={OERAW}
                    alt="ex1"
                  ></img>

                  <div class="hover_text">
                    <h3>OER-AW</h3>
                    <p>
                    {i18next.t("d7")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>


                </Link>
                
                </div>

              
            </div>
        </div>
      </div>
    </div>
  );
};

export default Software;
